// src/pages/Catalogue.js
import React from "react";

const Catalogue = () => {
  const catalogues = [
    {
      src: "https://online.anyflip.com/ophf/zzgh/index.html",
      height: "700px",
      fullWidth: true,
      title: "GURU Mens",
    },
    {
      src: "https://online.anyflip.com/ophf/vstj/index.html",
      height: "700px",
      fullWidth: true,
      title: "GURU Womens",
    },
    {
      src: "https://online.anyflip.com/ophf/vctk/index.html",
      height: "700px",
      fullWidth: true,
      title: "GURU Accesspries",
    },
    {
      src: "https://online.anyflip.com/ophf/gwll/index.html",
      height: "700px",
      fullWidth: true,
      title: "GURU Cricket",
    },
  ];

  return (
    <div className="container mx-auto px-4 py-10">
      <h1 className="text-2xl font-bold text-center mb-10">GURU BRANDBOOK</h1>

      <div className="flex flex-col items-center space-y-6">
        {catalogues.map((item, index) => (
          <iframe
            key={index}
            src={item.src}
            title={item.title}
            className={`shadow-md ${item.fullWidth ? "w-full" : "w-[550px]"}`}
            style={{ height: item.height }}
            seamless
            scrolling="no"
            frameBorder="0"
            allowTransparency={true}
            allowFullScreen
          ></iframe>
        ))}
      </div>
    </div>
  );
};

export default Catalogue;
